import React from 'react';
import { usePopperTooltip } from 'react-popper-tooltip';
import 'react-popper-tooltip/dist/styles.css';

const ScrollButton = ({ onClick, icon, tooltip }: { onClick: () => void; icon: React.ReactElement; tooltip: string }) => {
    const {
        getArrowProps,
        getTooltipProps,
        setTooltipRef,
        setTriggerRef,
        visible,
    } = usePopperTooltip({ placement: 'top' });

    return (
        <div ref={setTriggerRef} className="z-20">
            <button
                onClick={onClick}
                className="group focus:outline-none"
            >
                {React.cloneElement(icon, {
                    className: `text-blue-500 cursor-pointer transition-colors duration-200 
                      group-hover:text-white group-hover:bg-blue-500 rounded-full`
                })}
            </button>
            {visible && (
                <div
                    ref={setTooltipRef}
                    {...getTooltipProps({
                        className: 'tooltip-container',
                        style: {
                            minWidth: 'max-content',
                            whiteSpace: 'nowrap',
                            padding: '0.25rem 0.5rem',
                        }
                    })}
                >
                    <div {...getArrowProps({ className: 'tooltip-arrow' })} />
                    <p>{tooltip}</p>
                </div>
            )}
        </div>
    );
};

export default ScrollButton;